const userDropdown = {
    logout: {
        icon: 'poweroff',
        text: 'Logout',
        route: 'auth.logout'
    }
}

export default userDropdown
